import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flexible-pricing',
  templateUrl: './flexible-pricing.component.html',
  styleUrls: ['./flexible-pricing.component.scss']
})
export class FlexiblePricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
